import React from 'react'
import AdminDashboardPage from './AdminDashboardPage'

function AdminUsersPage() {
  return <AdminDashboardPage section="users" />
}

export default AdminUsersPage
